import { useMemo } from 'react';
import { DEFAULT_VALUE } from './HorizontalScrollContext';
export default function useHorizontalScrollContext(_ref) {
  var disabled = _ref.disabled,
    stickyColumns = _ref.stickyColumns,
    width = _ref.width;
  return useMemo(function () {
    return Object.assign({}, DEFAULT_VALUE, {
      disabled: disabled,
      stickyColumns: stickyColumns,
      width: width,
      containerRef: {},
      overflowRef: {},
      tableRef: {}
    });
  }, [disabled, stickyColumns, width]);
}